import { LoadersStorageModel } from './storage/loaders-storage.model';
import { BehaviorSubject } from 'rxjs';
import { LoaderNameType } from './types';
import { UsedLoaderModel } from './storage/used-loader.model';
import { filter } from 'rxjs/operators';

export class LoaderManagement {
  public visible: boolean = false;
  public subject: any = null;
  public additionalData: any = '';
  public runDelay: boolean = false;

  private delayStopNotifications: any[] = [];

  constructor(
    private storage: LoadersStorageModel = null,
    public loaderName: LoaderNameType,
    public dependencyLoaders: Array<LoaderNameType> = [],
    private registered: boolean = false
  ) {
    if (!(this.storage)) {
      console.error(`You must specify storage for the ${this.loaderName}.`);

      return;
    }

    this.visible = this.registered;

    this.preparationOfDependence();
    this.changeStatus();
  }

  private preparationOfDependence(): void {
    const index = this.dependencyLoaders.indexOf(this.loaderName);

    if (index + 1) {
      this.dependencyLoaders.splice(index, 1);
      console.error(`Relation loop. You used ${this.loaderName} in dependencies. The registered loader is also called ${this.loaderName}.`);
    }
  }

  private getSubject(): BehaviorSubject<null> {
    if (this.subject === null) {
      this.subject = new BehaviorSubject(null);
    }

    return this.subject.pipe(
      filter((value: any) => value !== null)
    )
  }

  private startOrStopDependencyLoaders(_isStart: boolean = false): void {
    this.dependencyLoaders.forEach((_loaderName) => {
      const loader: LoaderManagement = this.storage.getLoaderByName(_loaderName);

      if (loader) {
        if (_isStart) {
          loader.start();
        } else {
          loader.stop();
        }
      } else {
        if (_isStart) {
          this.storage.incrementLoader(_loaderName);
        } else {
          this.storage.decrementLoader(_loaderName);
        }
      }
    });
  }

  private changeStatus(): void {
    this.visible = this.storage.isUsed(this.loaderName);

    if (this.subject) {
      this.subject.next(this);
    }
  }

  public setAdditionalData(_additionalData: any = null) {
    if (_additionalData !== null) {
      this.additionalData = _additionalData;
    }
  }

  public subscribe(_function: any, ...args: any[]) {
    return this.getSubject().subscribe(_function, ...args);
  }

  public isRegistered(): boolean {
    return this.registered;
  }

  public setRegistered(): void {
    this.registered = true;
  }

  public updateDependencyLoaders(_dependencyLoaders: Array<LoaderNameType> = []): void {
    this.dependencyLoaders = _dependencyLoaders;
  }

  public start(): void {
    this.storage.incrementLoader(this.loaderName);
    this.changeStatus();

    this.startOrStopDependencyLoaders(true);
  }

  public stop(): void {
    this.storage.decrementLoader(this.loaderName);
    this.changeStatus();

    this.startOrStopDependencyLoaders(false);
  }

  public onDelay(): void {
    this.runDelay = true;
    this.getLoaderStorage().setTimestamp();
  }

  public getLoaderStorage(): UsedLoaderModel {
    return this.storage.getLoaderStorageByName(this.loaderName);
  }

  public runDelayNotifyAfterStop(): void {
    this.delayStopNotifications.forEach(function (_callback) {
      _callback();
    });

    this.delayStopNotifications = [];
  }

  public runAfterDelay(_callback: Function = null): void {
    if (_callback) {
      this.delayStopNotifications.push(_callback);

      if (!this.getLoaderStorage().isInTimeOfDelay()) {
        this.runDelayNotifyAfterStop();
      }
    }
  }
}
